import { SnackbarProvider } from 'notistack';
import type { FC } from 'react';
import type { IProps } from '@/Module/Core/Model/DataModel';
interface IApplicationSnackbarProviderProps extends IProps {}
const ApplicationSnackbarProvider: FC<IApplicationSnackbarProviderProps> = ({
  children
}) => {
  return <SnackbarProvider autoHideDuration={2000} anchorOrigin={{
    vertical: 'top',
    horizontal: 'right'
  }} data-sentry-element="SnackbarProvider" data-sentry-component="ApplicationSnackbarProvider" data-sentry-source-file="ApplicationSnackbarProvider.tsx">
      {children}
    </SnackbarProvider>;
};
export default ApplicationSnackbarProvider;